import { helloRetailInitScript, helloRetailReloadScript } from "./itnlIntegrationScriptsScripts";

export const getHelloRetailInitScripts = (helloRetailUUID: string, __hasHelloretailInitialized: boolean) => {

    return !__hasHelloretailInitialized ? {
        scriptContent: helloRetailInitScript(helloRetailUUID, true),
        id: "hello_retail_init_script",
    } : {
        scriptContent: helloRetailReloadScript(helloRetailUUID),
        id: "hello_retail_reload_script",
    }
}

